import { all, call, put, select, spawn, takeEvery } from 'redux-saga/effects';
import { fetchEntityIfNeeded, fetchEntity } from '@classpass/saga-tools';
import { cancelFlowStep, userProfile } from 'redux/saga/entities/bound';
import { push as updatePath } from 'react-router-redux';
import { NPS_SURVEY_SOURCE } from 'features/Settings/Membership/NpsSurvey/NpsSurvey.constants';
import { showModal } from 'redux/modules/modals';
import { querySelector } from 'redux/saga/selectors/request';
import { EXIT_TO_CX, EXIT_TO_SELF_CANCEL, STEP_PREFIX, STEP_SUFFIX, isDynamicStepId } from './models/ModelHelpers';
import {
  ACTIONS,
  COHORT,
  PAGE_TYPES,
  objectToQueryString,
  completedMembershipStepAnalytics,
  handleCancelFlowFailure,
  stepViewedAnalytics,
} from '../CancelAnalytics.saga';

export const CTA_CLICKED = 'cancelFlow.CTA_CLICKED';
export const CANCEL_STEP_CONFIRMATION_MODAL = 'CancelStepConfirmationModal';

export const ctaClick = (stepId, previousStep) => ({ type: CTA_CLICKED, stepId, previousStep });
export const loadCancelStepData = stepId => ({ type: 'classpass/cancelflow/loadCancelStep', stepId });

export function* doLoadCancelStepData(client, { stepId }) {
  const [{ cohort }, profile] = yield all([select(querySelector), call(fetchEntityIfNeeded, userProfile, [client])]);
  yield call(fetchEntity, cancelFlowStep, [
    client,
    profile.id,
    {
      use_offer: cohort === COHORT.test,
      step_id: stepId,
    },
  ]);
  yield spawn(stepViewedAnalytics, client, {
    step: stepId,
    page_type: PAGE_TYPES.cancelHold,
  });
}

export function* handleExitStep(stepId) {
  const isPlanChange = stepId.includes(STEP_SUFFIX.litePlan) || isDynamicStepId(stepId);
  if (stepId === EXIT_TO_CX) {
    yield put(updatePath('/settings/membership/update/cancel'));
  } else if (stepId === EXIT_TO_SELF_CANCEL) {
    yield put(updatePath(`/settings/nps-survey?source=${NPS_SURVEY_SOURCE.selfCancel}`));
  } else if (isPlanChange) {
    yield put(updatePath(`/settings/nps-survey?source=${NPS_SURVEY_SOURCE.planChange}`));
  } else {
    yield put(updatePath('/settings/nps-survey'));
  }
}

export function* doHandleCtaClick(client, { previousStep, stepId }) {
  try {
    if (stepId.startsWith(STEP_PREFIX.offer)) {
      const query = yield select(querySelector);
      query.previous = previousStep;
      const queryString = objectToQueryString(query);
      yield put(updatePath(`/settings/membership/update/cancel/steps/${stepId}?${queryString}`));
    } else if (stepId.startsWith(STEP_PREFIX.confirm)) {
      yield spawn(completedMembershipStepAnalytics, client, {
        action: ACTIONS.select,
        step: previousStep,
      });
      yield call(doLoadCancelStepData, client, { stepId });
      yield put(showModal(CANCEL_STEP_CONFIRMATION_MODAL, { stepId }));
    } else if (stepId.startsWith(STEP_PREFIX.exitTo)) {
      yield call(handleExitStep, stepId);
    } else {
      yield call(handleCancelFlowFailure, { message: 'Invalid step id' });
    }
  } catch (err) {
    yield call(handleCancelFlowFailure, err);
  }
}

export function* watchCancelStep(client) {
  yield takeEvery(ctaClick().type, doHandleCtaClick, client);
  yield takeEvery(loadCancelStepData().type, doLoadCancelStepData, client);
}
